<app-header></app-header>

<div class="mainwrapper">
  <div class="new-container">
    <div class="title-container">
      <div class="left">
        <h2>Cancer Ingress 2025 - USA</h2>
        <h4>
          Seasonal forecast focusing on domestic affairs, security, and the
          national mood.
        </h4>
      </div>
      <div class="right">
        <button>Edit</button>
        <button class="ingress-edit-btn">Share</button>
      </div>
    </div>

    <div class="glass-card">
      <div class="each-section">
        <p>LOCATION</p>
        <p>Washington D.C., USA</p>
      </div>
      <div class="each-section">
        <p>Event Timestamp (UTC)</p>
        <p>2025-06-21 02:43:24</p>
      </div>
      <div class="each-section">
        <p>Effective Period</p>
        <p>Jun 21 - Sep 22, 2025</p>
      </div>
      <div class="each-section">
        <p>Importance</p>
        <div style="display: flex; align-items: center; gap: 5px">
          <div class="dot"></div>
          <span>High Impact</span>
        </div>
      </div>
    </div>

    <div class="content-grid">
      <div class="left">
        <div class="title">
          <h2>System Interpretation</h2>
        </div>
        <div class="content-desc">
          <p class="italic-text">
            This period signals a profound focus on national identity and
            domestic security for the United States. With the Ascendant in
            Aquarius, themes of social progress, technological innovation, and
            collective ideals are at the forefront. However, the chart ruler,
            Saturn, is placed in the assertive and sometimes combative sign of
            Aries, suggesting that progress may come through conflict or
            decisive, forceful action.
          </p>
          <br />
          <p>
            The Cancer Ingress for 2025 places a powerful emphasis on the
            nation's foundational security, both emotionally and physically.
            With the Sun and Jupiter conjunct in Cancer in the 5th house,
            matters of national pride, creativity, and speculation (including
            financial markets) are highly energized. This suggests a period of
            potential growth and optimism, but also a risk of over-extension and
            nationalistic fervor. The public mood, represented by the Moon in
            Taurus in the 3rd house, is grounded and seeks stability,
            particularly in areas of communication and local community affairs.
            There may be a disconnect between the government's ambitious,
            speculative tone and the populace's desire for tangible, reliable
            security.
          </p>
          <br />
          <p>
            The most significant impact will be felt by government leaders and
            financial institutions. The Jupiter-Sun conjunction points to bold,
            expansive policies, but its position in the 5th house suggests these
            may be more performative than substantive. This energy directly
            impacts the U.S. Sibley chart's Sun, amplifying themes of national
            leadership. Technology sectors and social advocacy groups, guided by
            the Aquarius Ascendant, will also be prominent. They will push for
            progressive change, but may face resistance from established
            structures, as indicated by Saturn in Aries squaring the Cancer
            planets. This creates a tense dynamic between innovation and
            tradition.
          </p>
        </div>
      </div>
      <div class="right">
        <div class="sector-analysis">
          <h4>Sector Analysis</h4>
          <p>
            Government: Expansive but potentially risky policies. A push for
            nationalistic displays.
          </p>
          <p>
            Social Climate: A desire for stability clashes with a drive for
            progressive, disruptive change.
          </p>
          <p>
            Economy: Potential for speculative bubbles (5th house Jupiter).
            Focus on tangible assets (Moon in Taurus).
          </p>
        </div>
        <div class="tags">
          <h4>Tags</h4>
          <div class="tag-container">
            <div class="tag">Aquarius Rising</div>
            <div class="tag">Saturn in Aries</div>
            <div class="tag">Economy</div>
            <div class="tag">Government</div>
            <div class="tag">USA</div>
          </div>
        </div>
      </div>
    </div>

    <div class="related-chart">
        <h2>Related Insights</h2>
        <div class="chart-container">
            <div class="chart-card">
                <div class="chart-title">
                    <span>Mundane Forecast</span>
                </div>
            </div>
        </div>
    </div>
  </div>
</div>
